module.exports = __webpack_public_path__ + "arrow.png?5c929b47d241ab329f71d986f52aa6ee";